__turbopack_context__.v({
  "article": "templates-module__JdPBWG__article",
  "banner": "templates-module__JdPBWG__banner",
  "breadcrumbs": "templates-module__JdPBWG__breadcrumbs",
  "button": "templates-module__JdPBWG__button",
  "card": "templates-module__JdPBWG__card",
  "cardAction": "templates-module__JdPBWG__cardAction",
  "cardFooter": "templates-module__JdPBWG__cardFooter",
  "cardGrid": "templates-module__JdPBWG__cardGrid",
  "cardIcon": "templates-module__JdPBWG__cardIcon",
  "cardIntro": "templates-module__JdPBWG__cardIntro",
  "categories": "templates-module__JdPBWG__categories",
  "categoryLabel": "templates-module__JdPBWG__categoryLabel",
  "categoryNav": "templates-module__JdPBWG__categoryNav",
  "categorySelect": "templates-module__JdPBWG__categorySelect",
  "container": "templates-module__JdPBWG__container",
  "description": "templates-module__JdPBWG__description",
  "detail": "templates-module__JdPBWG__detail",
  "detailIntro": "templates-module__JdPBWG__detailIntro",
  "detailLayout": "templates-module__JdPBWG__detailLayout",
  "empty": "templates-module__JdPBWG__empty",
  "groupHeading": "templates-module__JdPBWG__groupHeading",
  "guide": "templates-module__JdPBWG__guide",
  "guideContents": "templates-module__JdPBWG__guideContents",
  "library": "templates-module__JdPBWG__library",
  "libraryLayout": "templates-module__JdPBWG__libraryLayout",
  "preview": "templates-module__JdPBWG__preview",
  "previewBody": "templates-module__JdPBWG__previewBody",
  "previewHeader": "templates-module__JdPBWG__previewHeader",
  "previewLoading": "templates-module__JdPBWG__previewLoading",
  "related": "templates-module__JdPBWG__related",
  "resultCount": "templates-module__JdPBWG__resultCount",
  "results": "templates-module__JdPBWG__results",
  "search": "templates-module__JdPBWG__search",
  "steps": "templates-module__JdPBWG__steps",
  "templateFacts": "templates-module__JdPBWG__templateFacts",
  "templateGroup": "templates-module__JdPBWG__templateGroup",
  "textLink": "templates-module__JdPBWG__textLink",
  "thumbnail": "templates-module__JdPBWG__thumbnail",
  "title": "templates-module__JdPBWG__title",
  "useTemplate": "templates-module__JdPBWG__useTemplate",
  "viewAll": "templates-module__JdPBWG__viewAll",
});
